// import { Button } from "react-bootstrap";
// import { FaAngleDoubleRight, FaAngleDoubleLeft } from "react-icons/fa";

// const Pagination = ({ currentPage, totalPages, onPageChange }) => {
//   const handleClick = (pageNumber) => {
//     if (pageNumber > 0 && pageNumber <= totalPages) {
//       onPageChange(pageNumber);
//     }
//   };

//   return (
//     <div
//       className="pagination-container mb-4"
//       style={{
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//       }}
//     >
//       <Button
//         variant="primary"
//         onClick={() => handleClick(currentPage - 1)}
//         disabled={currentPage === 1}
//         size="sm"
//         style={{
//           marginRight: "1rem",
//         }}
//       >
//         <FaAngleDoubleLeft />
//       </Button>
//       {Array.from({ length: totalPages }, (_, index) => (
//         <a
//           key={index + 1}
//           variant={index + 1 === currentPage ? "secondary" : "primary"}
//           onClick={() => handleClick(index + 1)}
//           style={{
//             marginRight: "2rem",
//             marginLeft: "2rem",
//           }}
//         >
//           {index + 1}
//         </a>
//       ))}
//       <Button
//         variant="primary"
//         onClick={() => handleClick(currentPage + 1)}
//         disabled={currentPage === totalPages}
//         size="sm"
//         style={{
//           marginLeft: "1rem",
//         }}
//       >
//         <FaAngleDoubleRight />
//       </Button>
//     </div>
//   );
// };

// export default Pagination;

import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const handleClick = (page) => {
    if (page > 0 && page <= totalPages) {
      onPageChange(page);
    }
  };

  const generatePages = () => {
    const pages = [];
    const visible = 5;
    const half = Math.floor(visible / 2);
    let start = Math.max(2, currentPage - half);
    let end = Math.min(totalPages - 1, currentPage + half);

    if (currentPage <= half) {
      end = visible;
    } else if (currentPage >= totalPages - half) {
      start = totalPages - visible + 1;
    }

    pages.push(renderPage(1));

    if (start > 2) pages.push(<span key="start-ellipsis" className="px-2 text-muted">…</span>);

    for (let i = start; i <= end; i++) {
      if (i > 1 && i < totalPages) pages.push(renderPage(i));
    }

    if (end < totalPages - 1) pages.push(<span key="end-ellipsis" className="px-2 text-muted">…</span>);

    if (totalPages > 1) pages.push(renderPage(totalPages));

    return pages;
  };

  const renderPage = (page) => (
    <button
      key={page}
      onClick={() => handleClick(page)}
      className={`px-3 py-1 mx-1 border-0 rounded ${
        page === currentPage ? 'bg-primary text-white fw-semibold' : 'bg-transparent text-dark'
      }`}
      style={{
        minWidth: '40px',
        transition: 'all 0.2s',
        cursor: 'pointer',
      }}
    >
      {page}
    </button>
  );

  const ArrowButton = ({ direction, disabled, onClick }) => (
    <button
      className="bg-transparent border-0 p-2 rounded"
      onClick={onClick}
      disabled={disabled}
      style={{
        color: disabled ? '#ccc' : '#333',
        cursor: disabled ? 'not-allowed' : 'pointer',
        transition: 'background 0.2s',
        minWidth: '36px',
        height: '36px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {direction === 'left' ? <FaChevronLeft size={16} /> : <FaChevronRight size={16} />}
    </button>
  );

  return (
    <div className="d-flex justify-content-center align-items-center flex-wrap mt-4 gap-2">
      <ArrowButton
        direction="left"
        disabled={currentPage === 1}
        onClick={() => handleClick(currentPage - 1)}
      />
      {generatePages()}
      <ArrowButton
        direction="right"
        disabled={currentPage === totalPages}
        onClick={() => handleClick(currentPage + 1)}
      />
    </div>
  );
};

export default Pagination;
